import HorizontalLogo from 'components/horizontal-logo/horizontal-logo.component';
import * as S from '../header/header.styles';

const PreviewHeader = () => {
  return (
    <S.Container position="fixed" data-testid="Header.Container">
      <S.ToolbarWrapper data-testid="Header.Container.ToolbarWrapper">
        <S.LogoLinkContainer>
          <HorizontalLogo />
        </S.LogoLinkContainer>
      </S.ToolbarWrapper>
    </S.Container>
  );
};
export default PreviewHeader;
